import { Vector2 } from "../../../common/vector2.js";
import { MoveDirection } from "../../../common/types.js";
import { CatmulromPrecomputed } from "../../utils/catmulrom_precomputed.js";
import { AMPLITUDE_TRAIL, RATE, LIFE_SPAN_TRAIL, FIREWORKS_COLORS } from "./fireworks_constants.js";
import { FireworksColor } from "./fireworks_types.js";
import { PayloadEmitter } from "../../core/emitters/payload_emitter.js";
import { VfxFireworksBatch } from "./vfx_fireworks_batch.js";
import { ImgID } from "../../../image_loader/img_id.js";

export class VfxFireworks_Trail
{
  private static readonly LIFE_SPAN          : number = LIFE_SPAN_TRAIL;
  private static readonly PARTICLE_LIFE_SPAN : number = 350;
  private static readonly RATE               : number = RATE;
  private static readonly MIN_SIZE           : number = 30;
  private static readonly MAX_SIZE           : number = 40;
  private static readonly MAX_ALPHA          : number = 0.4;
  private static readonly AMPLITUDE          : number = AMPLITUDE_TRAIL;

  public static spawn( batch: VfxFireworksBatch, from: Vector2, to: Vector2, color_type: FireworksColor, amplitude_direction: MoveDirection, now: number ): void
  {
    const color = FIREWORKS_COLORS.get( color_type );
    if ( !color ) throw new Error( `No value found for key: ${color_type}` );

    const scale = LayoutScaler.getScale();
    const amplitude = VfxFireworks_Trail.AMPLITUDE * amplitude_direction;

    const precomputed = CatmulromPrecomputed.calcPrecomputed( from, to, amplitude );
    
    // Calculate approximate spline length (straight line dist from p1 to p2) to determine particle count
    const dx = precomputed.p2.x - precomputed.p1.x;
    const dy = precomputed.p2.y - precomputed.p1.y;
    const dist = Math.hypot( dx, dy );
    
    // Matches the old rate_over_distance logic
    const particle_count = Math.max( 1, Math.floor( dist * ( VfxFireworks_Trail.RATE / scale ) ) );
    
    for ( let i = 0; i < particle_count; i++ )
    {
      const curve_t = particle_count > 1 ? i / (particle_count - 1) : 0.5;
      const start_time = now + curve_t * VfxFireworks_Trail.LIFE_SPAN;
      batch.spawnParticle(
        ImgID.CircleGlow2,
        precomputed.p1, precomputed.bp1, precomputed.bp2, precomputed.p2,
        new Vector2( 0, 0 ),
        curve_t,
        color,
        VfxFireworks_Trail.MAX_SIZE * scale,
        VfxFireworks_Trail.MIN_SIZE * scale,
        VfxFireworks_Trail.MAX_ALPHA,
        0.0,
        0.0,
        0.0, // additive=0 because batch is already Additive BlendMode
        start_time,
        VfxFireworks_Trail.PARTICLE_LIFE_SPAN
      );
    }
  }
}
